module.exports = __webpack_public_path__ + "static/img/logo.2aad7127.png";